import { getTheme, IStackStyles, Stack, Text } from '@fluentui/react';
import * as React from 'react';
import { borderBottomStyle } from '../shared/BorderStyles';

interface TitleBarProps {
  headerText: string;
}

export const TitleBar: React.FunctionComponent<TitleBarProps> = props => {
  const { palette } = getTheme();
  const borderBottom = borderBottomStyle(palette);
  const stackStyles: IStackStyles = {
    root: {
      background: palette.neutralLighter
    }
  };

  return (
    <Stack
      horizontal
      className="justify-content-start align-items-center py-3 px-2"
      styles={stackStyles}
      style={borderBottom}
    >
      <Stack.Item className="ml-5">
        <Text variant="xxLarge">{props.headerText}</Text>
      </Stack.Item>
    </Stack>
  );
};
